export default __webpack_public_path__ + "static/media/journeytray-greentree-fruitnutflower.bf83a57b.svg";